import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var path = process.env.VUE_APP_BASE_API;
import { mapGetters } from 'vuex';
import infoList from '@/mixins/infoList';
import { getFileList, deleteFile as _deleteFile } from '@/api/fileUploadAndDownload';
import { downloadImage } from '@/utils/downloadImg';
import { formatTimeToStr } from '@/utils/date';
import CustomPic from '@/components/customPic';
import UploadImage from '@/components/upload/image.vue';
export default {
  name: 'Upload',
  components: {
    CustomPic: CustomPic,
    UploadImage: UploadImage
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time !== null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      fullscreenLoading: false,
      listApi: getFileList,
      path: path,
      tableData: [],
      imageUrl: ''
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  created: function created() {
    this.getTableData();
  },
  methods: {
    deleteFile: function deleteFile(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.$confirm('此操作将永久文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 1;
                      return _deleteFile(row);
                    case 1:
                      res = _context.sent;
                      if (res.code === 0) {
                        _this.$message({
                          type: 'success',
                          message: '删除成功!'
                        });
                        if (_this.tableData.length === 1 && _this.page > 1) {
                          _this.page--;
                        }
                        _this.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))).catch(function () {
                _this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkFile: function checkFile(file) {
      this.fullscreenLoading = true;
      var isJPG = file.type === 'image/jpeg';
      var isPng = file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG或png 格式!');
        this.fullscreenLoading = false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        this.fullscreenLoading = false;
      }
      return (isPng || isJPG) && isLt2M;
    },
    uploadSuccess: function uploadSuccess(res) {
      this.fullscreenLoading = false;
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '上传成功'
        });
        if (res.code === 0) {
          this.getTableData();
        }
      } else {
        this.$message({
          type: 'warning',
          message: res.msg
        });
      }
    },
    uploadError: function uploadError() {
      this.$message({
        type: 'error',
        message: '上传失败'
      });
      this.fullscreenLoading = false;
    },
    downloadFile: function downloadFile(row) {
      downloadImage(row.url, row.name);
    }
  }
};